import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Layout } from "antd";
import Logo from "../assets/images/Travelebrium-logo.png";
import { Link } from "react-router-dom";

const AppHeader = (props) => {
  const { Header } = Layout;
  const navigate = useNavigate();
  const name = localStorage.getItem("name") || "";
  const host = window.location.hostname;

  const handleLogout = () => {
    localStorage.removeItem("login");
    navigate("/");
  };

  const login = JSON.parse(localStorage.getItem("login"));

  return (
    <Header className="public-header" style={{ paddingLeft: "20px" }}>
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <Link className="logo" to="/">
              <img src={Logo} alt="Travelebrium" />
            </Link>
          </div>
          <div className="col-lg-4">
            {login?.type && (
              <div className="text-end">
                <b>{login?.name}</b>
                <Button type="link" onClick={handleLogout}>
                  Logout
                </Button>
              </div>
            )}
            {"  "}
          </div>
        </div>
      </div>
    </Header>
  );
};

export default AppHeader;
